import { i18n } from '@/common/utils/i18n'

export const COMPETITORS_PLATFORM_LIST = [
    {
      label: 'Uber Eats',
      value: 'ubereats'
    },
    {
      label: 'Sindelantal',
      value: 'sindelantal'
    },
    {
      label: 'Rappi',
      value: 'rappi'
    }
  ]
export const PAY_TYPE = [
  {
    label: i18n._('线上支付'),
    value: 'online'
  },
  {
    label: i18n._('现金支付'),
    value: 'cash'
  }
]
export const DELIVERY_TYPE_LIST = [
    {
      label: i18n._('平台配送'),
      value: '1'
    },
    {
      label: i18n._('自配送'),
      value: '2'
    }
  ]

